import { CalcMaxDPAction, CalcMaxDPState } from 'src/modules/user-input/calcMaxDP/types.ts';
import { initialState } from 'src/modules/user-input/calcMaxDP/initialState.ts';
import { convert } from 'src/modules/user-input/convert.ts';

export const reducer = (prevState: CalcMaxDPState, action: CalcMaxDPAction): CalcMaxDPState => {
    let newState = { ...prevState };
    if (action.type === 'reset') {
        newState = {
            ...initialState,
        };
    }
    if (action.type === 'dpmv_change') {
        newState = {
            ...newState,
            dpmv: action.payload,
        };
    }
    if (action.type === 'pv_change') {
        newState = {
            ...newState,
            pv: action.payload,
        };
    }
    if (action.type === 'dpmv_unit') {
        newState = {
            ...newState,
            dpmv: convert(
                newState.dpmv,
                newState.dpmvUnit,
                action.payload,
            ),
            dpmvUnit: action.payload,
        };
    }

    return newState;
};
